import { Component } from "@angular/core";

@Component({
  selector: "app-entidades-home",
  templateUrl: "./entidades-home.component.html",
  styleUrls: ["./entidades-home.component.css"],
})
export class EntidadesHomeComponent {}
